import { ENVIRONMENT } from '../environment';

export const printAppStart = () => {
  const art = `
+--------------------------+
|██╗   ██╗ ██████╗ ███████╗|
|██║   ██║██╔═══██╗██╔════╝|
|██║   ██║██║   ██║█████╗  |
|██║   ██║██║   ██║██╔══╝  |
|╚██████╔╝╚██████╔╝███████╗|
| ╚═════╝  ╚═════╝ ╚══════╝|
+--------------------------+
    `;

  console.log(
    '%c' + art,
    'color: #00DCA5; font-family: monospace; font-size: 12px; font-weight: bold;'
  );
  console.log(
    '%c' + ENVIRONMENT.releaseVersion,
    'color: #00DCA5; font-family: monospace; font-size: 24px; font-weight: bold;'
  );
};
